// extracted by mini-css-extract-plugin
export default {"container":"OrganizationAddOrganism_container__Q3M22","imageContainer":"OrganizationAddOrganism_imageContainer__sNLt8"};